import { useInvalidateCarriersQuery } from "./use-carriers-query";
import type { ConditionalRulesDto, UpdateCarrierDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

interface UpdateCarrierConditionalRulesParams {
  carrierId: string;
  conditionalRules: ConditionalRulesDto | null;
}

export function useUpdateCarrierConditionalRules(shopId: string) {
  const invalidateCarriers = useInvalidateCarriersQuery({ shopId });

  return useApiMutation(
    "patch",
    "/shops/{shopId}/carriers/{carrierId}",
    {
      invalidate: invalidateCarriers,
      onError: (error) => {
        console.error('Failed to update carrier conditional rules:', error);
      },
      mapVariables: ({ carrierId, conditionalRules }: UpdateCarrierConditionalRulesParams) => ({
        params: { path: { shopId, carrierId } },
        body: { conditionalRules } as UpdateCarrierDto,
      }),
    },
  );
}
